<template>
  <div class="image-element-wrapper">
    <img :src="imageUrl" @load="onImageLoaded" @click="handlePreview" />
    <a-progress v-if="showProgressBar" :percent="percent" />
  </div>
</template>

<script>
export default {
  name: "ImageElem",
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  inject: ["message", "boxScrollToBottom"],
  computed: {
    imageUrl() {
      let arr = this.payload.imageInfoArray || this.payload.ImageInfoArray;
      const url = arr[0].url || arr[0].URL;
      if (typeof url !== "string") {
        return "";
      }
      return url.slice(0, 2) === "//" ? `https:${url}` : url;
    },
    showProgressBar() {
      return this.message.status === "unSend";
    },
    percent() {
      return Math.floor((this.message.progress || 0) * 100);
    }
  },
  methods: {
    onImageLoaded(event) {
      // this.$bus.$emit('image-loaded', event)
      this.boxScrollToBottom();
    },
    handlePreview() {}
  }
};
</script>

<style lang="scss" scoped>
img {
  max-width: 100%;
}
</style>
